/**
 * The tenant the UI is currently working on, published for the API layer.
 *
 * `createApiClient` adds it as `X-Tenant-Id` to every request that does not
 * set the header itself. The control-plane forwarder routes by that header,
 * and it is the only way to route calls that carry no tenant in their path
 * (the import-job poll and list). On a tenant container the server checks it
 * against the bound tenant, so a stale value surfaces as a 403, never as the
 * wrong tenant's data.
 *
 * Publishers: `AppLayout` (from the `/tenant/:tenantId` path) and
 * `PortalTenantProvider` (the portal's scoped tenant). Calls made outside a
 * tenant context, such as the tenant list, carry no header.
 */
let activeTenantId: string | null = null;

export function setActiveTenant(tenantId: string | null | undefined): void {
  activeTenantId = tenantId && tenantId.trim() ? tenantId.trim() : null;
}

export function getActiveTenant(): string | null {
  return activeTenantId;
}
